import { reactive, readonly } from 'vue'

const state = reactive({
  id: undefined,
  name: undefined,
  account: {},
  roles: [],
})

const methods = {
  getId() {
    return state.id
  },
  setId(id) {
    state.id = id
  },
  getName() {
    return state.name
  },
  setName(name) {
    state.name = name
  },
  getAccount() {
    return state.account
  },
  setAccount(account) {
    state.account = account
  },
  getRoles() {
    return state.roles
  },
  setRoles(roles) {
    state.roles = roles
  },
  /**
   * @param {string} roleName
   * @returns {boolean}
   */
  hasRole(roleName) {
    return state.roles.map(role => role.name).indexOf(roleName) !== -1
  },
  /**
   * @param {array} roleNameList
   * @returns {boolean}
   */
  hasAllRoles(roleNameList) {
    const userRoleNames = state.roles.map(role => role.name)
    let result = true
    roleNameList.every((name) => {
      if (userRoleNames.indexOf(name) === -1) {
        result = false
        return false // break out of "every" loop after the first name that is NOT found
      }
      return true
    })
    return result // return true if all names are found
  },
  /**
   * @param {array} roleNameList
   * @returns {boolean}
   */
  hasAnyRoles(roleNameList) {
    const userRoleNames = state.roles.map(role => role.name)
    let result = false
    roleNameList.every((name) => {
      if (userRoleNames.indexOf(name) !== -1) {
        result = true
        return false  // break out of "every" loop after the first name that is found
      }
      return true
    })
    return result // return false if none of the names are found
  },
}

export default {
  name: 'UserDetailsStore',
  state: readonly(state),
  methods,
}
